import React from 'react';
import banner from './img/courses-bannner.png'
import './LinuxPage.css';
import CareerForm from './careerform';
import Footer from '../Components/footer'

const ciscoPage = () => {
  return (
    <div className='cisco-container'>
       <div className='cisco-banner-box'>
                  <div className='cisco-banner'>
        <img src={banner} alt=''/>
                  </div>
                </div>

<div className='detail-box'>
    <div className='cisco-heading'>
        <h1>Linux Course </h1>
        <p>Linux is an open source operating system (OS) created by Linus Torvalds in 1991. Today, it has a massive user base, and is used in the world’s 500 most powerful supercomputers. Users gravitate toward it for its versatility and security capabilities, among other reasons. The Linux kernel is maintained by a worldwide community of open source enthusiasts and has hundreds of unique distros.
</p>
        </div> 

         <div className='carrer-section'>
        <div className='skills-section'>
<h2>🛡️ Top Linux Skills You’ll Master</h2>
<div className='skills-name'>
<span>Linux installation and file system management</span>
<span>Command Line Interface (CLI)</span>
</div>
<div className='skills-name'>
<span>User and permission management</span>
<span>Shell scripting and automation</span>
</div>
<div className='skills-name'>
<span>Server configuration and security</span>
</div>

        </div>
 <div className='job-roles'>
           <h1>💼 JOB ROLES AFTER LINUX COURSE</h1>
           <div className='job-name'>
            <span>Linux System Administrator</span>
            <span>DevOps Engineer</span>
            </div>
             <div className='job-name'>
            <span>Cloud Engineer (Linux-Based)</span>
            <span>System Engineer</span>
            </div>
             <div className='job-name'>
            <span>Technical Support Engineer</span>
           </div>
        </div>
        </div>
        <div className='course-discription'>
            <h1>About this Course</h1>
<p>A Linux course teaches you the foundations of the open-source Linux operating system. It equips you with skills to navigate the command-line interface, manage file systems, handle user permissions, monitor system performance, and automate tasks through shell scripting. Linux runs over 90% of the world's servers, cloud platforms, and cybersecurity tools — yet most people never learn it properly. Our Linux course takes you from zero to confident, covering the command line, file systems, networking, shell scripting, and system administration.

</p>
        </div>
        </div>
        <div className='join-container'>
        <div className='join-box'>
<div className='join-div'>
<h1>Who Should Join This Linux Course</h1>
<p><span> ✔ </span>Students who want to start their IT journey with Linux basics. </p>
<p><span> ✔ </span>Freshers ready to build strong skills for real IT jobs. </p>
<p><span> ✔ </span>Beginners who want to learn Linux from zero, step by step. </p>
<p><span> ✔ </span>Tech learners curious to understand how systems run behind the scenes. </p>
<p><span> ✔ </span>IT beginners aiming to gain practical command-line skills. </p>
<p><span> ✔ </span>Working professionals who want to upgrade into system & server roles. </p>
<p><span> ✔ </span> Developers who want to work smoothly in Linux environments.</p>
<p><span> ✔ </span>Freelancers looking to offer server setup and support services. </p>
<p><span> ✔ </span>Self-learners searching for a simple and guided Linux learning path. </p>
<p><span> ✔ </span> Anyone who wants a powerful, in-demand and future-ready tech skill.</p>

</div>
        </div>

                <CareerForm/>
        </div>

    <div className="modules-container">

      {/* Heading */}
      <h1 className="module">Course RoadMap</h1>
      <p className="subtitle">
        Step-by-step modules to master Linux Course
      </p>

      {/* Grid */}
      <div className="modules-grid">

        {/* Card 1 */}
        <div className="module-card">
          <div className="circle">01</div>
          <h3>Linux Overview</h3>
          <p>
         Understand Linux basics, distributions, and open-source operating system fundamentals clearly.
          </p>
        </div>

        {/* Card 2 */}
        <div className="module-card">
          <div className="circle">02</div>
          <h3>Linux Installation & Setup</h3>
          <p>
            Learn Linux installation, system setup, and initial configuration for beginners.
          </p>
        </div>

        {/* Card 3 */}
        <div className="module-card">
          <div className="circle">03</div>
          <h3>Command Line Interface (CLI)</h3>
          <p>
          Master Linux terminal commands for file management, navigation, and system control.
          </p>
        </div>

        {/* Card 4 */}
        <div className="module-card">
          <div className="circle">04</div>
          <h3>File System Management</h3>
          <p>
           Understand Linux file structure, permissions, and efficient file handling techniques.
          </p>
        </div>

        {/* Card 5 */}
        <div className="module-card">
          <div className="circle">05</div>
          <h3>User & Group Management</h3>
          <p>
           Learn user accounts, groups, permissions, and access control management basics.
          </p>
        </div>

        {/* Card 6 */}
        <div className="module-card">
          <div className="circle">06</div>
          <h3>Process Management</h3>
          <p>
           Monitor, control, and manage system processes using essential Linux commands.
          </p>
        </div>

      </div>

        {/* Grid */}
      <div className="modules-grid">

        {/* Card 7 */}
        <div className="module-card">
          <div className="circle">07</div>
          <h3>Package Management</h3>
          <p>
         Install, update, and manage software packages using apt, yum, and repositories.
          </p>
        </div>

        {/* Card 8 */}
        <div className="module-card">
          <div className="circle">08</div>
          <h3>Networking in Linux</h3>
          <p>
            Configure network settings, IP addressing, and troubleshoot connectivity issues effectively.
          </p>
        </div>

        {/* Card 9 */}
        <div className="module-card">
          <div className="circle">09</div>
          <h3>Shell Scripting Basics</h3>
          <p>
          Automate tasks using basic shell scripting and command-line programming concepts.
          </p>
        </div>

        {/* Card 10 */}
        <div className="module-card">
          <div className="circle">10</div>
          <h3>System Monitoring & Logs</h3>
          <p>
           Track system performance, logs, and troubleshoot issues using monitoring tools.
          </p>
        </div>

        {/* Card 11 */}
        <div className="module-card">
          <div className="circle">11</div>
          <h3>Security & Permissions</h3>
          <p>
          Implement file permissions, firewalls, and basic Linux system security practices.
          </p>
        </div>

        {/* Card 12 */}
        <div className="module-card">
          <div className="circle">12</div>
          <h3>Practical Linux Labs</h3>
          <p>
           Hands-on practice with real Linux tasks, commands, and troubleshooting scenarios.
Linux
          </p>
        </div>

      </div>
    </div>

<div>
        <Footer/>
</div>
    </div>
  )
}

export default ciscoPage